const customSelect = document.querySelector(".custom-select");
const selectBtn = document.querySelector(".custom-select__select-button");

const selectedValue = document.querySelector(".custom-select__selected-value .sort-value");
const optionsList = document.querySelectorAll(".custom-select__select-dropdown li");

// add click event to select button
selectBtn.addEventListener("click", (e) => {
  // add/remove active class on the container element
  customSelect.classList.toggle("active");
  // update the aria-expanded attribute based on the current state
  selectBtn.setAttribute(
    "aria-expanded",
    selectBtn.getAttribute("aria-expanded") === "true" ? "false" : "true"
  );
});

optionsList.forEach((option) => {
  function handler(e) {
    // Click Events
    if (e.type === "click" && e.clientX !== 0 && e.clientY !== 0) {
      selectedValue.textContent = ": " + this.children[1].textContent;
      customSelect.classList.remove("active");
    }
    // Key Events
    if (e.key === "Enter") {
      selectedValue.textContent = this.textContent;
      customSelect.classList.remove("active");
    }
  }

  option.addEventListener("keyup", handler);
  option.addEventListener("click", handler);
});
